export const getUrlPathName = url => {
  return new URL(url).pathname
}
